import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl} from "@angular/forms";
import { NbIconModule, NbInputModule } from '@nebular/theme';
import {Subscription} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,NbIconModule, NbInputModule],
})
export class SearchInputComponent implements OnInit, OnDestroy {
  @Input() searchText: string = '';
  @Input() placeholder: string = '';
  @Input() searchStyle: string = 'search-input';
  @Output() searchTextChange = new EventEmitter<string>();
  formControl: UntypedFormControl;
  subscription: Subscription[] = [];

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.createFormControl();
    this.subscribeToFormControl();
  }

  ngOnDestroy() {
    this.subscription.forEach(subsc => {
      if (subsc && !subsc.closed) {
        subsc.unsubscribe();
      }
    });
  }

  createFormControl() {
    this.formControl = this.fb.control(this.searchText ?? '');
  }

  subscribeToFormControl() {
    const subsc = this.formControl.valueChanges.pipe(
      debounceTime(1000),
    ).subscribe(value => {
      this.searchText = value;
      this.searchTextChange.emit(value);
    });
    this.subscription.push(subsc);
  }
}
